export const allRoles = [
  "MGMT",
  "SD1",
  "SD2",
  "RIT",
  "REVMGMT",
  "REOADM",
  "IT",
];
